import { Grid, Typography } from "@mui/material";
import { format, parseISO } from "date-fns";
import { StyledSiniestralidad } from "../../../../../../styled/Siniestros";

const DinerariasCard = ({ data }) => {

  return (
    <>
      {data?.length ? (
        data?.map((liquidacion) => {
          return (
            <StyledSiniestralidad.Card key={liquidacion.idliquidacion}>
              <Grid container spacing={2}>
                <Grid item xs={2}>
                  <Typography>
                    {format(parseISO(liquidacion?.fechaLiquidacion), "yyyyMM")}
                  </Typography>
                </Grid>

                <Grid item xs={5}>
                  <Typography>{liquidacion?.tipoLiquidacion}</Typography>
                </Grid>

                <Grid
                  item
                  xs={3}
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Typography>
                    {Intl.NumberFormat("es-AR").format(liquidacion?.importe)}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={2}
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Typography>{liquidacion?.estado}</Typography>
                </Grid>
              </Grid>
            </StyledSiniestralidad.Card>
          );
        })
      ) : (
        <StyledSiniestralidad.EmptyState variant="body1">
          No hay liquidaciones disponibles
        </StyledSiniestralidad.EmptyState>
      )}
    </>
  );
};

export default DinerariasCard;
